// Arabic translations for Dawr

import common from './common.json';
import automotive from './automotive.json';
import navigation from './navigation.json';
import auth from './auth.json';
import search from './search.json';
import profile from './profile.json';
import posts from './posts.json';
import services from './services.json';
import categories from './categories.json';
import locations from './locations.json';
import forms from './forms.json';
import errors from './errors.json';

const arTranslations = {
  common,
  automotive,
  navigation,
  auth,
  search,
  profile,
  posts,
  services,
  categories,
  locations,
  forms,
  errors,
};

export default arTranslations;
